import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import AuthPage from "@/pages/Auth";
import Workspace from "@/pages/Workspace";
import Conversations from "@/pages/Conversations";
import Tasks from "@/pages/Tasks";
import TaskDetail from "@/pages/TaskDetail";
import MemoryPage from "@/pages/Memory";
import Integrations from "@/pages/Integrations";
import SettingsPage from "@/pages/Settings";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen" data-testid="auth-checking" />;
  if (user === false) return <Navigate to="/auth" replace />;
  return children;
};

const P = (el) => <Protected>{el}</Protected>;

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/c/:id" element={P(<Workspace />)} />
            <Route path="/conversations" element={P(<Conversations />)} />
            <Route path="/tasks" element={P(<Tasks />)} />
            <Route path="/tasks/:id" element={P(<TaskDetail />)} />
            <Route path="/memory" element={P(<MemoryPage />)} />
            <Route path="/integrations" element={P(<Integrations />)} />
            <Route path="/settings" element={P(<SettingsPage />)} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121212", border: "1px solid #2A2A2A", color: "#F8F4E6", borderRadius: 2 } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
